export const styleScope = 'raw-explorer-style-scope';
